import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15 7h-.5V5c0-.6-.4-1-1-1h-.9V1H3.4v3h-.9c-.6 0-1 .4-1 1v2H1c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1h2.4v1h9.2v-1H15c.6 0 1-.4 1-1V8c0-.6-.4-1-1-1m-2.4-2h.9v2h-.9zM4.4 2h7.2v5H4.4zM2.5 5h.9v2h-.9zm9.1 9H4.4v-3h7.2zm3.4-1h-2.4v-1.3l.8-.9c.1-.1.2-.4.1-.5-.1-.2-.3-.3-.5-.3H3c-.2 0-.4.1-.5.3s0 .4.1.5l.8.9V13H1V8h14zm-9.5-1h5v1h-5z" />
  </svg>
);
const SvgPrinterNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="printer-next" {...props} />;
export default SvgPrinterNext;
